import Reward from 'views/Reward'

const RewardPage = () => {
  return <Reward />
}

RewardPage.Layout = RewardPage
// RewardPage.mp = false

export default RewardPage
